import { addMonths, addYears } from "date-fns";
import { enums } from "@shared/constants";

export interface CalculateNextExpiryDateParams {
  isRenewalItemGroup: boolean;
  renewalFrequency?: string;
  renewalMemberExpiryDate?: string;
}

/**
 * Calculates the next expiry date for a renewal membership item group
 * @param params - Parameters for calculating next expiry date
 * @returns The next expiry date or null if not applicable
 */
export function calculateNextExpiryDate({
  isRenewalItemGroup,
  renewalFrequency,
  renewalMemberExpiryDate,
}: CalculateNextExpiryDateParams): Date | null {
  if (!isRenewalItemGroup) {
    return null;
  }

  const isExpired = renewalMemberExpiryDate
    ? new Date(renewalMemberExpiryDate) < new Date()
    : false;

  const currentExpiryDate =
    !isExpired && renewalMemberExpiryDate
      ? new Date(renewalMemberExpiryDate)
      : new Date();

  switch (renewalFrequency) {
    case enums.RENEWAL_FREQUENCIES_MAP_BY_ID.monthly.id:
      return addMonths(currentExpiryDate, 1);

    case enums.RENEWAL_FREQUENCIES_MAP_BY_ID.every_3_months.id:
      return addMonths(currentExpiryDate, 3);

    case enums.RENEWAL_FREQUENCIES_MAP_BY_ID.every_6_months.id:
      return addMonths(currentExpiryDate, 6);

    case enums.RENEWAL_FREQUENCIES_MAP_BY_ID.yearly.id:
      return addYears(currentExpiryDate, 1);

    case enums.RENEWAL_FREQUENCIES_MAP_BY_ID.one_time.id:
    case enums.RENEWAL_FREQUENCIES_MAP_BY_ID.lifetime.id:
    case enums.RENEWAL_FREQUENCIES_MAP_BY_ID.seasonal.id:
      return null;

    default:
      return null;
  }
}
